import {PagingPayload} from '../constants';
import {IWrapper} from '../types';
import {CashbackRequestsResponse, ICashbackRequest} from '../types/endpoints';

/**
 * CashbackRequestEndpoint class implements ICashbackRequest interface
 */
class CashbackRequestEndpoint implements ICashbackRequest {
  readonly wrapper: IWrapper;

  /**
   * Constructor
   * @param {IWrapper} wrapper - The wrapper instance
   */
  constructor(wrapper: IWrapper) {
    this.wrapper = wrapper;
  }

  /**
   * Get cashback requests
   */
  public getCashbackRequests(): Promise<CashbackRequestsResponse> {
    return this.wrapper.get<CashbackRequestsResponse>(
      '/v2/cashback-requests',
      PagingPayload,
    );
  }
}

export default CashbackRequestEndpoint;
